import React from 'react'
import CameraIcon from './icons/CameraIcon'

const StaffTableSnippet = ({staff, hidePhoto = false}) => {
    return (
        <div className='flex items-center gap-x-2'>
            {!hidePhoto && <div className='bg-gray-50 h-[50px] w-[50px] rounded-[8px] flex items-center justify-center' style={{
              backgroundImage: `url(" ${staff?.photo} ")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              backgroundRepeat: 'none'
            }}>
                {(!staff?.photo || staff?.photo === '') &&
                    <CameraIcon className={`w-6 h-6 text-gray-400`} />
                }
            </div>}
            <div>
                <p className='text-sm'>{`${staff?.firstName}${staff?.otherNames ? ` ${staff?.otherNames} ` : ' '}${staff?.lastName}`}</p>
                <p className='text-sm text-gray-500'>{staff?.email}, {staff?.phone}</p>

            </div>
        </div>
      )
}

export default StaffTableSnippet
